import { render, staticRenderFns } from "./DraggableMenu.vue?vue&type=template&id=836f8d5e&scoped=true&"
import script from "./DraggableMenu.vue?vue&type=script&lang=js&"
export * from "./DraggableMenu.vue?vue&type=script&lang=js&"
import style0 from "./DraggableMenu.vue?vue&type=style&index=0&id=836f8d5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "836f8d5e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('836f8d5e')) {
      api.createRecord('836f8d5e', component.options)
    } else {
      api.reload('836f8d5e', component.options)
    }
    module.hot.accept("./DraggableMenu.vue?vue&type=template&id=836f8d5e&scoped=true&", function () {
      api.rerender('836f8d5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/contacts/DraggableMenu.vue"
export default component.exports